import React from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";

const MobileMenuOpenData = ({ isOpen, closeMenu, location }) => {
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <nav
            className="navbar navbar-mobile"
            style={{
                position: "fixed",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                background: "rgba(51, 60, 79, 0.9)",
                zIndex: 1000,
            }}
        >
            <i
                className="bi mobile-nav-toggle bi-x"
                onClick={closeMenu}
                style={{
                    position: "absolute",
                    top: "15px",
                    right: "15px",
                    fontSize: "28px",
                    cursor: "pointer",
                }}
            ></i>
            <ul
                style={{
                    display: "block",
                    position: "absolute",
                    top: "55px",
                    right: "15px",
                    bottom: "15px",
                    left: "15px",
                    padding: "10px 0",
                    borderRadius: "6px",
                    backgroundColor: "#fff",
                    overflowY: "auto",
                    transition: "0.3s",
                }}
            >
                <li>
                    <Link
                        to="/open_data"
                        className={`nav-link scrollto ${location.pathname === "/open_data" ? "active" : ""
                            }`}
                        onClick={closeMenu}
                    >
                        Beranda
                    </Link>
                </li>
                <li>
                    <Link
                        to="/open_data/kumpulan_data"
                        className={`nav-link scrollto ${location.pathname === "/open_data/kumpulan_data" ? "active" : ""
                            }`}
                        onClick={closeMenu}
                    >
                        Kumpulan Data
                    </Link>
                </li>
                <li>
                    <Link
                        to="/open_data/organisasi"
                        className={`nav-link scrollto ${location.pathname === "/open_data/organisasi" ? "active" : ""
                            }`}
                        onClick={closeMenu}
                    >
                        Organisasi
                    </Link>
                </li>
                <li>
                    <Link
                        to="/open_data/kategori"
                        className={`nav-link scrollto ${location.pathname === "/open_data/kategori" ? "active" : ""
                            }`}
                        onClick={closeMenu}
                    >
                        Kategori
                    </Link>
                </li>
                <li>
                    <Link
                        to="/open_data/infografik"
                        className={`nav-link scrollto ${location.pathname === "/open_data/infografik" ? "active" : ""
                            }`}
                        onClick={closeMenu}
                    >
                        Infografik
                    </Link>
                </li>
                <li>
                    <Link
                        to="/open_data/tentang"
                        className={`nav-link scrollto ${location.pathname === "/open_data/tentang" ? "active" : ""
                            }`}
                        onClick={closeMenu}
                    >
                        Tentang
                    </Link>
                </li>
            </ul>
        </nav>,
        document.body
    );
};

export default MobileMenuOpenData;
